var map = {
	"./CanvasClear": 73,
	"./CanvasClear.js": 73,
	"./CanvasMove": 74,
	"./CanvasMove.js": 74,
	"./CommandAbstract": 26,
	"./CommandAbstract.js": 26,
	"./ComponentDelete": 75,
	"./ComponentDelete.js": 75,
	"./ComponentDrag": 76,
	"./ComponentDrag.js": 76,
	"./ComponentEnter": 77,
	"./ComponentEnter.js": 77,
	"./ComponentExit": 78,
	"./ComponentExit.js": 78,
	"./ComponentNext": 79,
	"./ComponentNext.js": 79,
	"./ComponentPrev": 80,
	"./ComponentPrev.js": 80,
	"./ComponentStyleClear": 81,
	"./ComponentStyleClear.js": 81,
	"./CopyComponent": 82,
	"./CopyComponent.js": 82,
	"./CreateComponent": 28,
	"./CreateComponent.js": 28,
	"./DeleteComponent": 29,
	"./DeleteComponent.js": 29,
	"./ExportTemplate": 27,
	"./ExportTemplate.js": 27,
	"./Fullscreen": 39,
	"./Fullscreen.js": 39,
	"./MoveComponent": 30,
	"./MoveComponent.js": 30,
	"./OpenAssets": 36,
	"./OpenAssets.js": 36,
	"./OpenBlocks": 35,
	"./OpenBlocks.js": 35,
	"./OpenLayers": 32,
	"./OpenLayers.js": 32,
	"./OpenStyleManager": 33,
	"./OpenStyleManager.js": 33,
	"./OpenTraitManager": 34,
	"./OpenTraitManager.js": 34,
	"./PasteComponent": 83,
	"./PasteComponent.js": 83,
	"./Preview": 40,
	"./Preview.js": 40,
	"./Resize": 41,
	"./Resize.js": 41,
	"./SelectComponent": 11,
	"./SelectComponent.js": 11,
	"./SelectParent": 38,
	"./SelectParent.js": 38,
	"./SelectPosition": 18,
	"./SelectPosition.js": 18,
	"./ShowOffset": 37,
	"./ShowOffset.js": 37,
	"./SwitchVisibility": 31,
	"./SwitchVisibility.js": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;